<template>
  <div class="checklist-inspection">
    <r-title
      v-if="data.title"
      class="checklist-inspection__header"
      color-type="subhead"
    >
      {{ data.title }}
    </r-title>
    <div class="checklist-inspection__captions">
      <r-title type="subtitle-1">
        {{ data.radioButtonHeaders ? data.radioButtonHeaders.true : `Есть` }}
      </r-title>
      <r-title type="subtitle-1">
        {{
          data.radioButtonHeaders
            ? data.radioButtonHeaders.false
            : `Отсутствует`
        }}
      </r-title>
    </div>
    <div class="checklist-inspection__content">
      <checklist-inspection-list
        v-for="list in data.lists"
        :key="list.id"
        :list="list"
        :app_source_id="app_source_id"
        :data-title="data.title"
        :app_source="app_source"
        :app_docs="app_docs"
      />
    </div>
  </div>
</template>

<script>
import checklistInspectionList from './checklist-inspection-list'

export default {
  components: { checklistInspectionList },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => null
    },
    app_source: {
      type: Object,
      required: true
    },
    app_docs: {
      type: Array,
      default: () => []
    },
    app_source_id: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.checklist-inspection {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: 1fr 1fr;

  &__content {
    border-radius: var(--border-radius);
    border: 1px solid var(--field_border);
    display: grid;
    padding: 0.5rem 1rem;
    grid-column: 1 / 3;
    grid-gap: 1rem;
  }

  &__header {
    grid-column: 1 / 3;
  }

  &__captions {
    padding: 0 1rem 0 0.5rem;
    grid-column: 2 / 3;
    display: grid;
    grid-auto-flow: column;
    justify-content: center;
    grid-gap: 0.5rem;

    .r-title {
      width: 6rem;
      text-align: center;
    }
  }
}
</style>
